import { render, staticRenderFns } from "./JoyStick.vue?vue&type=template&id=29d4928a&scoped=true&"
import script from "./JoyStick.vue?vue&type=script&lang=js&"
export * from "./JoyStick.vue?vue&type=script&lang=js&"
import style0 from "./JoyStick.scss?vue&type=style&index=0&id=29d4928a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d4928a",
  null
  
)

export default component.exports